module.exports = __webpack_public_path__ + "static/img/文案策划-pr稿.226fa30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10008/文案策划-pr稿.png
// module id = txyx
// module chunks = 1